import { render, staticRenderFns } from "./ChanghongInsecticidalLamp.vue?vue&type=template&id=a051793a&scoped=true"
import script from "./ChanghongInsecticidalLamp.vue?vue&type=script&lang=js"
export * from "./ChanghongInsecticidalLamp.vue?vue&type=script&lang=js"
import style0 from "./ChanghongInsecticidalLamp.vue?vue&type=style&index=0&id=a051793a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a051793a",
  null
  
)

export default component.exports